export default __webpack_public_path__ + "static/plk-case-study.en-44c00293759a286b09403deb91c8ca3b.pdf";